import React from 'react';
import FCMMessage from "../containers/FCMMessage/FCMMessage";

export const FCMMessagePage = () => <FCMMessage />;

